<script type="text/javascript">
	import Spinner from "../Spinner/Spinner.svelte";
	import SpinnerSize from "../Spinner/SpinnerSize";

	export let style;
	let spinnerStyle = style + `;
		background-color:#ddd;
		padding-top:8px;
		padding-bottom:6px;
		border-radius:3px;
		text-align:center;`;

	export let percentage = "";
</script>

<div class='button-spinner' style={spinnerStyle}>
	<Spinner size={SpinnerSize.MINI} absolute={false} inline={true} percentage={percentage}/>
	<slot/>
</div>
